<template>
  <div
      @click="goTo(`/vacancies/${vacancy.id}${queryParams}`)"
      class="vacancy-card"
      :class="{ 'vacancy-card_draft': draft }"
  >
    <div v-if="!closed && vacancy.can_edit"  @click.stop="goTo(`/vacancies/${vacancy.id}/edit${queryParams}`)" class="vacancy-card__edit-btn">
      <Pencil icon-color="black" />
    </div>
    <p class="vacancy-card__date">{{ vacancy.date }}</p>
    <h3 class="vacancy-card__title">{{ vacancy.title ? vacancy.title : 'Без названия' }}</h3>
<!--    <p class="vacancy-card__active-tasks" :class="{ 'vacancy-card__active-tasks_active': vacancy.tasks_count }"-->
<!--       v-if="!draft">-->
<!--      Активные задачи:-->
<!--      <span class="vacancy-card__active-tasks-num">{{ vacancy.tasks_count }}</span>-->
<!--    </p>-->
    <p class="vacancy-card__author">
    Автор: {{ vacancy.vacancy_owner_employee ? vacancy.vacancy_owner_employee?.full_name : '' }}
    </p>

<!--    <div v-if="vacancy?.hiring_fact_count && vacancy?.hiring_plan_count && !draft" class="vacancy-card__slider">-->
    <div v-if="!draft" class="vacancy-card__slider">
      <div class="vacancy-card__slider-title">
        <div>Трудоустроено</div>
        <div><span>{{vacancy.hiring?.fact}}</span>/{{vacancy.hiring?.plan}}</div>
      </div>

      <VSlider :current="vacancy.hiring?.fact" :max="vacancy.hiring?.plan" class="vacancy-card__slider-item" no-number two-color="#26A659" />
    </div>

    <div class="vacancy-card__responses" v-if="!draft" @click.stop="onVacancyCardClick">
      <p class="vacancy-card__responses-text"
         v-if="vacancy.user_responses_count || vacancy.user_responses_new_count">
        Отклики
        <span class="vacancy-card__responses-text-num">
                    {{ vacancy.user_responses_count }}
                    {{ vacancy.user_responses_new_count ? `(+${vacancy.user_responses_new_count})` : '' }}
                </span>
      </p>
      <p class="vacancy-card__responses-text" v-else>Нет откликов</p>
    </div>
  </div>
</template>

<script setup>
import {useRouter, useRoute} from "vue-router"
import {computed} from "vue";
import Pencil from "@/components/Icons/Pencil.vue";

const router = useRouter()
const route = useRoute()
const props = defineProps({
  vacancy: {
    type: Object,
    required: true
  },
  draft: {
    type: Boolean,
    default: false
  },
  closed: {
    type: Boolean,
    default: false
  },
  index: {
    type: Number,
  }
})

const onVacancyCardClick = () => {
  router.push({
    path: `/responses`,
    params: {vacancyId: props.vacancy.id},
    query: {vacancyId: props.vacancy.id},
    hash: route.hash,
  })
}

const goTo = (path) => {
  router.push({path})
}
const queryParams = computed(() => {
  const searchParams = new URLSearchParams();

  for (const [key, value] of Object.entries(route.query)) {
    if (value !== undefined && value !== null) {
      searchParams.append(key, value);
    }
  }
  return '?' + searchParams.toString()
})
</script>

<style scoped lang="scss">
.vacancy-card {
  position: relative;
  cursor: pointer;
  //height: 181px;
  padding: 18px 16px 16px 16px;
  border-radius: 16px;
  background-color: #fff;
  box-shadow: 2px 2px 8px 0px #0000000A;
  color: $dark;
  text-decoration: none;
  transition: .3s;

  &:hover {
    box-shadow: 2px 2px 24px 0px #1E39591F;
  }

  &:hover > .vacancy-card__edit-btn {
    display: flex;
  }

  &__author {
    font-size: 14px;
    font-weight: 400;
    color: $dark-blue;
  }

  &__slider {
    margin-top: 21px;
  }

  &__slider-title {
    display: flex;
    justify-content: space-between;
    color: $dark-blue;
    font-size: 12px;
    font-weight: 400;

    span {
      font-size: 14px;
      font-weight: 500;
    }
  }

  &__slider-item {
    margin-top: 8px;
  }

  &_draft {
    //height: 85px;
    padding: 16px;
  }

  &__edit-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $light;
    transition: .3s;
    cursor: pointer;
    display: none;
    z-index: +1;

    &:hover {
      background-color: $light-gray-1;
    }

    &:active {
      background-color: $light-gray-2;
    }
  }

  &__date {
    color: $gray;
    font-size: 12px;
  }

  &__title {
    max-width: 90%;
    height: 34px;
    margin-top: 6px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: $dark;
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
    overflow: hidden;
  }

  &_draft &__title {
    margin-top: 4px;
  }

  &__active-tasks {
    margin-top: 8px;
    display: flex;
    align-items: center;
    color: $dark-blue;
    font-size: 14px;
    font-weight: 400;
  }

  &__active-tasks-num {
    height: 16px;
    margin-left: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
  }

  &__responses {
    width: 100%;
    height: 48px;
    margin-top: 20px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $light;
    color: $dark;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      background-color: $light-gray-1;
    }

    &:active {
      background-color: $light-gray-2;
    }
  }

  &__responses-text {
    font-size: 14px;
    font-weight: 500;
  }

  &__responses-text-num {
    color: $blue;
  }
}
</style>
